import find from "lodash/find";
import get from "lodash/get";
import memoize from "lodash/memoize";
import sortBy from "lodash/sortBy";
import toString from "lodash/toString";

const _FORECASTING_ALLOWED = [
  "88105c18-c8d2-41ad-a613-6f3f5bfb7009" // FTO
];

const DEFAULT_STATE = {
  categoriesList: [],
  fetching: false,
  fetched: false,
  error: null,
};

export default function categoryReducer(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case "FETCH_CATEGORIES":
      return { ...state, fetching: true };
    case "FETCH_CATEGORIES_REJECTED":
      return {
        ...state,
        fetching: false,
        error: action.payload
      };
    case "FETCH_CATEGORIES_FULFILLED":
      return handleCategoryFulfillment(state, action);
    default:
      return state;
  }
}

function handleCategoryFulfillment(state, action) {
  const categoriesList = normalizeCategoriesToList(action.payload);

  return {
    ...state,
    fetching: false,
    fetched: true,
    categoriesList,
  };
}

function normalizeCategoriesToList(payload) {
  if (!Array.isArray(payload)) {
    console.warn("got unexpected category payload");
    console.dir({ payload });

    return [];
  }

  return sortBy(payload, nameFor).map(normalizeCategory);
}

function normalizeCategory(rawCategory) {
  const name = nameFor(rawCategory);

  const { id } = rawCategory;

  // Preserved legacy comment:
  // Ideally, allowForecasting would come from the API. However,
  // I'm not sure it's worth all that work for what looks one
  // field that we get to define. We'll hard code it here in the
  // meantime.
  const allowForecasting = _FORECASTING_ALLOWED.includes(id);

  const fields = maybeAdjustFields(rawCategory);

  const category = {
    ...rawCategory,
    allowForecasting,
    fields,
    getId() {
      return id;
    },
  };

  return category;
}

function maybeAdjustFields(rawCategory) {
  let fields = get(rawCategory, "fields", []);

  fields = maybeMigrateOnsiteDetailField(fields, rawCategory);

  return fields;
}

// The name of the "With customer?" field. Name is due to evolution of how the field
// actually ended up being used, originally was dependent on onsite
const OSD_ID = "onsiteDetail";

// If a category name contains these, it should default
// the onsiteDetail "required" to hidden.
const OSD_HIDDEN_NEEDLES = [
  "FTO",
  "Holiday",
  "Professional Development",
  "General Office",
  "Internal Meetings",
  "R&D",
  "Proactive Work",
  "Productivity services",
  "Presales",
  "Development/Testing"
];

function maybeMigrateOnsiteDetailField(fields, rawCategory) {
  const name = nameFor(rawCategory);

  const onsiteDetailField = find(fields, ["id", OSD_ID]);

  if (onsiteDetailField) {
    if (process.env.NODE_ENV === "development") {
      console.warn("already got OSD field for %s", name);
      console.dir({ onsiteDetailField });
    }

    return fields;
  }

  const required = shouldHideOnsiteDetailByDefault(name) ? "hidden" : "required";

  const newField = { id: OSD_ID, required };

  if (process.env.NODE_ENV === "development") {
    console.debug("adding OSD field to category %s", name);

    console.dir(newField);
  }

  fields.push(newField);

  return fields;
}

function shouldHideOnsiteDetailByDefault(name) {
  if (!name) {
    return false;
  }

  return OSD_HIDDEN_NEEDLES.some((needle) => name.includes(needle));
}

const nameFor = memoize(function(category) {
  return toString(get(category, "name", ""));
});

function orderByName(a, b) {
  return nameFor(a).localeCompare(nameFor(b));
}



// WEBPACK FOOTER //
// ./app/reducers/timeInput/categories.js